import { dateFormat } from '@/helpers/common';

export enum ProfileField {
  COUNTRY = 'country',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  DATE_OF_BIRTH = 'date_of_birth',
  GENDER = 'gender',
}

export interface ICompleteProfileFrom {
  country?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: {
    day?: string;
    month?: string;
    year?: string;
  };
  gender?: string;
}

export const formatDateOfBirth = (
  dateOfBirth: ICompleteProfileFrom['dateOfBirth']
) => {
  if (dateOfBirth?.day && dateOfBirth?.month && dateOfBirth?.year) {
    return dateFormat(
      `${dateOfBirth.day}/${dateOfBirth.month}/${dateOfBirth.year}`
    );
  }
  return null;
};
